import React from "react";
import PropTypes from "prop-types";
import QuoteBox from "~/Components/Global/QuoteBox";
import LoadMore from "~/Components/Global/LoadMore";

class LoadMoreContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { page: 1, hasMore: false, type: this.props.type, items: [] };
  }
  componentDidMount() {
    this.fetch();
  }

  pagination = (e) => {
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
    if (this.fetching || this.props.loading || !this.state.hasMore) {
      return;
    }
    this.fetching = true;
    this.fetch();
  };

  fetch = () => {
    this.props.request(this.state.page).then(({ data }) => {
      const hasMore = data.length === 30;
      const items = this.state.items;
      data.map((t) => items.push(t));
      this.setState({ items, page: this.state.page + 1, hasMore });
    });
  };

  render = () => {
    const items = this.state.items;
    const { type, hasMore } = this.state;
    const { loading } = this.props;
    if (!loading && items.length === 0) {
      return null;
    }
    return (
      <React.Fragment>
        {items &&
          items.map((quote) => (
            <div key={quote.id}>
              <QuoteBox quote={quote} />
            </div>
          ))}

        <LoadMore loading={loading} hasMore={hasMore} items={items} pagination={this.pagination} infinite={this.props.infinite} />
      </React.Fragment>
    );
  };
}

LoadMoreContainer.defaultProps = {};
export default LoadMoreContainer;
